/**
 * Abstract class for logging messages to external services.
 * Implementations handle platform-specific logging (Sentry, Application Insights, etc.)
 */
export abstract class MessageLogger {
  /**
   * Logs an message to the configured logging platforms.
   * @param message - The message to log
   */
  abstract logMessage(message: string): void;
}
